import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { StrategyStepTemplateDTO } from 'crono-fe-common/types/DTO/strategyStepTemplateDTO';
import { StrategyStepTemplate } from 'crono-fe-common/types/DTO/strategyStepTemplates';

// This hook has 2 different responses:
// The first response will always be an array with 2 elements: [ originalTemplate, newABTestingTemplate ]
// All the following responses after that will be an array with 1 element: [ newABTestingTemplate ]

export default function useAddStrategyStepTemplate() {
  const queryClient = useQueryClient();

  const addStrategyStepTemplate = (stepTemplate: StrategyStepTemplateDTO) => {
    const request: Request = {
      url: `${ENDPOINTS.strategy.stepTemplate}`,
      config: {
        method: 'post',
        data: { data: stepTemplate },
      },
    };
    return client(request);
  };

  return useMutation<
    Response<StrategyStepTemplate[]>,
    CronoError,
    StrategyStepTemplateDTO
  >(addStrategyStepTemplate, {
    onSettled: (result, error, variables) => {
      queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.main]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.details]);
    },
  });
}
